"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = resolveProfileImages;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _clientAwsS = require("@devsta/client-aws-s3");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function resolveProfileImages(a, b, c) {
  if (!a.length || !b) return a.map(function (a) {
    return _objectSpread(_objectSpread({}, a), {}, {
      imageUrl: void 0
    });
  });

  try {
    return (0, _clientAwsS.replaceBucketKeysWithUrlsInArray)({
      apiClient: c,
      dataArray: a,
      organisationId: b,
      substitutedKeys: ["imageUrl"]
    });
  } catch (b) {
    return a.map(function (a) {
      return _objectSpread(_objectSpread({}, a), {}, {
        imageUrl: void 0
      });
    });
  }
}